import Config from '../utils/Config.js';

export default class BonusPanel extends Phaser.Group {
    constructor(game, { value, label, formatFunction, direction = 'horizontal' })
    {
        super(game, null);

        if (typeof formatFunction !== 'function')
        {
            formatFunction = (num) => '' + num;
        }

        this.params = { value, label, formatFunction, direction };

        const bg = new Phaser.Image(game, 0, 0, 'panels.bonus-win.bg');
        if (direction === 'vertical')
        {
            bg.rotation = (Math.PI * 90) / 180;
            bg.anchor.y = 1;
        }
        this.addChild(bg);

        const valueText = this._valueText = new Phaser.Text(game,
            direction === 'vertical' ? bg.height >> 1 : bg.width >> 1,
            direction === 'vertical' ? (bg.width >> 1) + 2 : (bg.height >> 1) + 2,
            formatFunction(value),
            {
                font: Config.DEFAULT_FONT,
                fontSize: 30,
                fontWeight: 'bold',
                fill: '#000',
                align: direction === 'vertical' ? 'center' : 'left'
            }
        );
        valueText.anchor.set(0.5);
        this.addChild(valueText);

        const labelText = this._labelText = new Phaser.Text(game,
            direction === 'vertical' ? (bg.height >> 1) : bg.width >> 1,
            direction === 'vertical' ? bg.width : bg.height - 8,
            label,
            {
                font: Config.DEFAULT_FONT,
                fontSize: 18,
                fontWeight: 'bold',
                fill: '#FFF',
                align: direction === 'vertical' ? 'center' : 'left'
            }
        );
        labelText.lineSpacing = -10;
        labelText.anchor.set(0.5, 0);
        this.addChild(labelText);

        this.value = value;
    }

    get value()
    {
        return this._value || 0;
    }

    set value(num)
    {
        this._valueText.text = this.params.formatFunction(num);
        this._value = num;
    }
}
